export enum ClaimSteps {
  CaptureModelNumber = 1,
  FaultCapture = 2,
  AdditionalInfo = 3,
  FaultStartDate = 4,
  ValidateDetails = 5,
  ServiceOptions = 6,
  EngineerBooking = 7,
}
